import { FC } from 'react';
import { FieldPattern } from '..';

import { INFORMED_OTP_FIELD } from '../../../../constants/FieldTypeConstants';
import { FormFieldsType } from '../../../../types/FieldModelTypes';

import FormFieldWithInitialValue from '../FormFieldWithInitialValue';

class InformedOTPFieldModel extends FormFieldWithInitialValue {
  readonly type: string = INFORMED_OTP_FIELD;
  fieldType!: string;
  otpInputType?: string;
  shouldShowIcon: boolean;
  focusIcon?: FC<any>;
  isFieldDisabled = false;
  reRenderedFields!: Array<string>;
  constructor(
    textFieldData: FormFieldsType,
    initialValue = '',
    fieldType = 'informedOTPField',
    shouldShowIcon = false,
    focusIcon?: FC<any>,
    reRenderedFields: Array<string> = []
  ) {
    super(textFieldData, initialValue);
    this.fieldType = fieldType;
    this.shouldShowIcon = shouldShowIcon;
    this.focusIcon = focusIcon;
    this.isFieldDisabled = initialValue ? true : false;
    this.reRenderedFields = reRenderedFields;
    this.placeholder = textFieldData.placeholder;
    this.otpInputType = textFieldData.otpInputType;
  }
  match<T>(p: FieldPattern<T>): T {
    return p.InformedOTPField(this);
  }
}

export default InformedOTPFieldModel;
